import React, { useCallback, useState } from 'react'
import { Button, Field, Input, VStack } from '@chakra-ui/react'

export namespace Login {
    type Props = {
        onLogin: (type: string, data: unknown) => void
        onCancel?: () => void
    }

    export const Component = ({ onLogin }: Props) => {
        const [email, setEmail] = useState('')
        const [password, setPassword] = useState('')

        const handleLogin = useCallback(() => {
            onLogin('email_password', {
                email,
                password
            })
        }, [email, password, onLogin])

        return (
            <VStack align="stretch" gap={4}>
                <Field.Root>
                    <Field.Label>Email address</Field.Label>
                    <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
                </Field.Root>

                <Field.Root>
                    <Field.Label>Password</Field.Label>
                    <Input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                </Field.Root>

                <Button
                    colorPalette="teal"
                    disabled={!(email && password)}
                    onClick={handleLogin}
                    alignSelf="flex-start"
                >
                    Login
                </Button>
            </VStack>
        )
    }
}
